import { render } from "./ClientApprovalComponent.vue?vue&type=template&id=4fbd0933&scoped=true"
import script from "./ClientApprovalComponent.vue?vue&type=script&lang=js"
export * from "./ClientApprovalComponent.vue?vue&type=script&lang=js"

import "./ClientApprovalComponent.vue?vue&type=style&index=0&id=4fbd0933&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbd0933"]])

export default __exports__